import {useState} from 'react';
import {useEventCallback} from 'usehooks-ts';
import {IPluginHooks} from '../ToolbarPlugin/types';
import {
    INSERT_ORDERED_LIST_COMMAND,
    INSERT_UNORDERED_LIST_COMMAND,
    REMOVE_LIST_COMMAND
} from '@lexical/list';
import {createDispatchCommandWithoutPayload} from '../ToolbarPlugin/utils';

export const useFormatList = ({editor}: IPluginHooks) => {
    const [blockType, setBlockType] = useState<string | null>('paragraph');
    const dispatchCommand = createDispatchCommandWithoutPayload(editor);

    const isBulletList = blockType === 'ul';
    const formatBulletList = useEventCallback(() => {
        editor.update(() => {
            const command = !isBulletList ? INSERT_UNORDERED_LIST_COMMAND : REMOVE_LIST_COMMAND;
            dispatchCommand(command);
        });
    });

    const isNumberList = blockType === 'ol';
    const formatNumberedList = useEventCallback(() => {
        const command = !isNumberList ? INSERT_ORDERED_LIST_COMMAND : REMOVE_LIST_COMMAND;
        dispatchCommand(command);
    });

    return {
        setBlockType,
        formatBulletList,
        formatNumberedList
    } as const;
};
